<template>
	<div :class="theme">
		<div class="header">
			<div v-if="language === 'zh'" class="zh">
				<div class="title">{{ jsonData.name }}</div>
				<div class="code">股票代码：{{ jsonData.companyCode }} | 所属行业：{{ jsonData.xfhy }}</div>
			</div>
			<div v-else-if="language === 'en'" class="en">
				<div class="title">{{ jsonData.nameEng }}</div>
				<div class="code">Stock Code：{{ jsonData.companyCode }} ｜ Industry：{{ jsonData.xfhyEng }}</div>
			</div>
			<div class="menu" @click="showMenu">
				<img :src="menuImg" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Header',
	data() {
		return {}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData']),
		menuImg() {
			return require('../assets/image/' + this.theme + '/menu.png')
		},
	},
	methods: {
		showMenu() {
			this.$emit('showMenu')
		},
	},
}
</script>

<style lang="scss" scoped>
.header {
	position: relative;
	padding-top: 23px;
}
.zh {
	text-align: center;
}
.zh .title {
	height: 33px;
	font-size: 24px;
	font-weight: 600;
	color: var(--headerColor);
	line-height: 33px;
}
.zh .code {
	height: 20px;
	font-size: 14px;
	font-weight: 400;
	color: var(--headerColor);
	line-height: 20px;
}

.en {
	margin-left: 57px;
}

.en .title {
	height: 33px;
	font-size: 22px;
	font-weight: 600;
	color: var(--headerColor);
	line-height: 33px;
}

.en .code {
	height: 20px;
	font-size: 14px;
	font-weight: 400;
	color: var(--headerColor);
	line-height: 20px;
}

.menu {
	position: absolute;
	top: 40px;
	left: 0px;
}
.menu img {
	width: 28px;
	height: 25px;
	cursor: pointer; /* 设置光标形状为手型 */
}
.blue {
	.header {
		background: linear-gradient(90deg, #4782ea 0%, #5db6fc 100%);
		padding-bottom: 14px;
	}

	.menu {
		position: absolute;
		top: 40px;
		left: 50px;
	}
	.en {
		margin-left: 107px;
	}
}
.yellow {
	.header {
		background: #151517;
		padding-bottom: 16px;
	}

	.menu {
		position: absolute;
		top: 40px;
		left: 50px;
	}
	.en {
		margin-left: 107px;
	}
}
</style>
